"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("../../util/Promise");

var _Error = _interopRequireDefault(require("../../components/common/templates/Error.html"));

var _processForwardedAction = _interopRequireDefault(require("../../util/title-actions/processForwardedAction"));

var _HashManager = _interopRequireDefault(require("../../components/common/HashManager"));

var _TitleCollection = _interopRequireDefault(require("../media/models/TitleCollection"));

var _PatronTitleStatus = _interopRequireDefault(require("../../models/PatronTitleStatus"));

var _PageManager = _interopRequireDefault(require("./PageManager"));

var _CollectionManager = _interopRequireDefault(require("./CollectionManager"));

var _CollectionHighlight = _interopRequireDefault(require("../collection_highlight/views/CollectionHighlight"));

var _SlantedCollectionHightlight = _interopRequireDefault(require("../collection_highlight_slanted/SlantedCollectionHightlight"));

var _CollectionHighlightFactory = _interopRequireDefault(require("./CollectionHighlightFactory"));

var _Campaign = _interopRequireDefault(require("../campaign/views/Campaign"));

var _LibbyTout = _interopRequireDefault(require("../libby_tout/LibbyTout.html"));

var _querystring = _interopRequireDefault(require("querystring"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var _window = window,
    Logger = _window.Logger,
    Waypoint = _window.Waypoint,
    html = _window.html;
var _window$OverDrive = window.OverDrive,
    isAuthenticated = _window$OverDrive.isAuthenticated,
    hasLinkedCards = _window$OverDrive.hasLinkedCards;

var PageView =
/*#__PURE__*/
function (_Backbone$View) {
  _inherits(PageView, _Backbone$View);

  _createClass(PageView, [{
    key: "generateHeroPlaceholderEl",
    // LHTNG-2082: Visual palceholder for Hero section
    value: function generateHeroPlaceholderEl() {
      return $('<div class="Hero" style="min-height: 480px" />');
    }
  }]);

  function PageView(_ref) {
    var _this;

    var viewId = _ref.viewId,
        room = _ref.room,
        bus = _ref.bus,
        featureManager = _ref.featureManager,
        patronSettings = _ref.patronSettings;

    _classCallCheck(this, PageView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PageView).apply(this, arguments));
    _this.viewId = viewId;
    _this.room = room;
    _this.bus = bus;
    _this.featureManager = featureManager;
    _this.patronSettings = patronSettings;
    _this.pageSize = 10;
    _this.lazyWaypointIndex = 2;
    _this.pageManager = new _PageManager["default"]();
    _this.collectionManager = new _CollectionManager["default"]();
    _this.views = [];
    _this.collectionErrors = []; // Provide a way to simulate collections and campaigns failing to load.  This helps with testing dynamic
    // collection loading logic.

    _this.collectionIndexesToFail = null;
    _this.failCampaign = false;
    var rawParams = window.location.search[0] === '?' ? window.location.search.substr(1) : window.location.search;

    var queryParams = _querystring["default"].parse(rawParams);

    var collectionsToFail = queryParams.collectionsToFail;

    if (collectionsToFail && collectionsToFail.length > 0) {
      _this.collectionIndexesToFail = collectionsToFail.split(',').map(function (val) {
        return parseInt(val, 10);
      });
    }

    _this.failCampaign = Boolean(queryParams.failCampaign);
    var forcedSlantedGridCollections = queryParams.forcedSlantedGridCollections;

    if (forcedSlantedGridCollections && forcedSlantedGridCollections.length > 0) {
      _this.forcedSlantedGridCollectionIndexes = forcedSlantedGridCollections.split(',').map(function (v) {
        return parseInt(v, 10);
      });
    }

    _this.forceAllSlantedGridCollections = Boolean(queryParams.forceAllSlantedGridCollections);
    var slantedGridTitleCountOverride = queryParams.slantedGridTitleCountOverride;

    if (slantedGridTitleCountOverride) {
      _this.slantedGridTitleCountOverride = slantedGridTitleCountOverride;
    }

    _this.update();

    return _this;
  }

  _createClass(PageView, [{
    key: "update",
    value: function update() {
      var _this2 = this;

      this.$el.empty();
      this.views.forEach(function (view) {
        return view.remove();
      });
      this.views = [];
      this.pageManager.fetchRoomById(this.room && this.room.id || 'home').then(function () {
        _this2.views = _this2.initViews();
        _this2.unrenderedViews = _this2.views.slice();

        _this2._loadPage();
      });
    }
  }, {
    key: "_loadPage",
    value: function _loadPage() {
      var isFirstPage = this.unrenderedViews.length === this.views.length;

      this._renderPage(this.pageSize, isFirstPage ? this.lazyWaypointIndex : 0);

      if (isFirstPage) {
        this._renderLibbyTout();
      }
    }
  }, {
    key: "_renderPage",
    value: function _renderPage(rowCount) {
      var _this3 = this;

      var wayPointIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (wayPointIndex && wayPointIndex < rowCount - 1) {
        // Paint the whole set of collections right away so scrolling speed is consistent
        // before and after you trigger the waypoint for lazy-loading.
        this._paintCollections(this.unrenderedViews.slice(0, rowCount));

        this._fetchRows(wayPointIndex + 1).then(function (collections) {
          _this3._updatePatronTitleStatus(collections); // Should this really be here?  We can just do it right away if we want at the cost of _potentially_ one
          // extra patron title status call.  Meh.


          _this3._performForwardedAction();

          if (_this3.views[wayPointIndex]) {
            var $el = _this3.views[wayPointIndex].$el;
            var waypoint = $('<div></div>');
            $el.after(waypoint);
            var breakpoint = new Waypoint.Inview({
              element: waypoint,
              enter: function enter() {
                breakpoint.destroy();

                if (typeof newrelic !== 'undefined') {
                  newrelic.addPageAction('lazyLoadWaypointHit', {
                    page: 'homepage'
                  });
                }

                _this3._fetchRows(rowCount - (wayPointIndex + 1)).then(function (_collections) {
                  _this3._updatePatronTitleStatus(_collections);

                  _this3._pageLoadComplete();
                });
              }
            });
          }
        });
      } else {
        this._fetchRows(rowCount).then(function (collections) {
          _this3._updatePatronTitleStatus(collections);

          _this3._pageLoadComplete();
        });
      }
    }
  }, {
    key: "_fetchRows",
    value: function _fetchRows(rowCount) {
      var _this4 = this;

      var collectionsDone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var views = this.unrenderedViews.splice(0, rowCount);

      this._paintCollections(views);

      return new Promise(function (resolve) {
        _this4._syncRows(views, collectionsDone).then(function (result) {
          if (result.failed) {
            _this4._fetchRows(result.failed, collectionsDone).then(function (collections) {
              resolve(collections);
            });
          } else {
            resolve(collectionsDone);
          }
        });
      });
    }
  }, {
    key: "_syncRows",
    value: function _syncRows(views, collections) {
      var requestQueue = views.map(function (view) {
        return view.sync();
      });
      return Promise.settle(requestQueue).then(function (results) {
        var succeeded = results.filter(function (result) {
          return result.fulfilled && result.value;
        });
        var failed = results.filter(function (result) {
          return !result.fulfilled || !result.value;
        });
        succeeded.map(function (request) {
          return collections.push(request.value);
        });

        if (failed.length) {
          // Make sure we make errors visible for debugging
          failed.forEach(function (failure) {
            if (failure && failure.value) {
              console.error(failure.value);
            }
          });
        }

        return {
          failed: failed.length
        };
      });
    }
  }, {
    key: "_paintCollections",
    value: function _paintCollections(views) {
      var frag = document.createDocumentFragment();
      views.forEach(function (view) {
        if (!view.isPainted) {
          frag.appendChild(view.el);
          view.isPainted = true;
        }
      });
      this.el.appendChild(frag);
    }
  }, {
    key: "_pageLoadComplete",
    value: function _pageLoadComplete() {
      var _this5 = this;

      if (this.unrenderedViews.length > 0) {
        var $loadMore = $("<button class=\"center u-allCaps button radius no-outline\">".concat(html('loadMore'), "</button>")).on('click', function () {
          _this5._loadPage();

          $loadMore.remove();
        });
        this.$el.append($loadMore);
      }

      if (this.collectionErrors.length > 0) {
        var allCollectionsFailed = this.views.length === 0;

        this._logPageErrors(this.collectionErrors, allCollectionsFailed);

        if (allCollectionsFailed) {
          this.$el.empty().append((0, _Error["default"])());
        }
      }

      this.collectionErrors = [];
    }
  }, {
    key: "_logPageErrors",
    value: function _logPageErrors(failed, allFailed) {
      var howMany = allFailed ? 'Total' : 'Partial';
      var errors = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = failed[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var failure = _step.value;
          errors.push({
            'id': failure.id,
            'type': failure.type,
            'statusText': failure.statusText,
            'status': failure.status
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var counts = _.countBy(errors, function (error) {
        return error.type + ':' + error.statusText;
      });

      Logger.log('error', "".concat(howMany, " HomePage Ajax Error"), {
        message: 'HighlightErrorRollup',
        errors: errors,
        counts: counts,
        page: 'home'
      });
    }
  }, {
    key: "initViews",
    value: function initViews() {
      var _this6 = this;

      var views = [];
      var campaigns = this.pageManager.getCampaigns();
      var showCampaign = campaigns && campaigns.length > 0 && !window.OverDrive.isVisitor;

      if (showCampaign) {
        this.campaign = null;
        this.campaignView = new _Campaign["default"]({
          bus: this.bus,
          currentRoom: this.room
        });
        this.campaignView.$el.append(this.generateHeroPlaceholderEl());
        views.push(this.campaignView);

        this.campaignView.sync = function () {
          return _this6.pageManager.fetchCampaignById(campaigns[0].id).then(function (campaign) {
            _this6.campaign = !_(campaign).isEmpty() && !_(campaign).isEmpty(campaign.items) && campaign;

            if (_this6.campaign && !_this6.failCampaign) {
              _this6.campaignView.campaign = _this6.campaign;

              _this6.campaignView.model.set(_this6.campaign.items[0]);

              _this6.campaignView.model.updatePatronState();

              _this6.campaignView.render();

              return _this6.campaignView;
            } else {
              _this6.campaignView.remove();

              _this6.removeView(_this6.campaignView);

              _this6.campaignView = null;
            }
          }, function (error) {
            error.id = campaigns[0].id;
            error.statusText = !!error.statusText ? error.statusText : 'UnknownStatus';
            error.type = 'Ajax Error: Campaign';

            _this6.campaignView.remove();

            _this6.removeView(_this6.campaignView);

            _this6.collectionErrors.push(error);

            _this6.campaignView = null;
            throw error;
          });
        };
      }

      var view = this.pageManager.getView(this.viewId);

      if (this._shouldTruncateCollections) {
        view.collectionDefinitions = view.collectionDefinitions.slice(0, 10);
      }

      this.collectionManager.reset(view.collectionDefinitions);
      this.collectionManager.each(function (collectionDefinition, index) {
        var isHero = !showCampaign && index === 0; // TODO: Thought is that the TitleCard template will render in "dummy" state

        collectionDefinition.titleCollection.reset([{
          placeholder: true
        }, {
          placeholder: true
        }, {
          placeholder: true
        }, {
          placeholder: true
        }, {
          placeholder: true
        }, {
          placeholder: true
        }]);
        var viewArgs = {
          model: collectionDefinition,
          bus: _this6.bus,
          featureManager: _this6.featureManager,
          room: _this6.room,
          isHero: isHero
        };

        if (_this6.slantedGridTitleCountOverride) {
          viewArgs.titleCountOverride = _this6.slantedGridTitleCountOverride;
        }

        var forceSlantedGridView = _this6.forceAllSlantedGridCollections || _this6.forcedSlantedGridCollectionIndexes && _this6.forcedSlantedGridCollectionIndexes.includes(index);

        if (forceSlantedGridView) {
          collectionDefinition.shuffle = true;
        }

        var collectionHighlightView = _CollectionHighlightFactory["default"].Build(collectionDefinition, viewArgs, forceSlantedGridView);

        collectionDefinition.pageSize = collectionHighlightView.desiredTitleCount;

        if (isHero) {
          collectionHighlightView.$el.append(_this6.generateHeroPlaceholderEl());
        }

        views.push(collectionHighlightView.render());

        collectionHighlightView.sync = function () {
          return collectionDefinition.fetchCollectionTitles({
            patronSettings: _this6.patronSettings,
            room: _this6.room
          }).then(function () {
            var simulateFailure = _this6.collectionIndexesToFail && _this6.collectionIndexesToFail.includes(index);

            if (collectionDefinition.titleCollection.length && !simulateFailure) {
              collectionHighlightView.render();
              collectionHighlightView.toggleTitleVisibility(true);
              return collectionDefinition;
            } else {
              // Clean up the failed row
              collectionHighlightView.remove();

              _this6.removeView(collectionHighlightView);

              throw new Error('No collection contents retrieved');
            }
          }, function (error) {
            collectionHighlightView.remove();

            _this6.removeView(collectionHighlightView);

            error.id = collectionDefinition.id;
            error.statusText = !!error.statusText ? error.statusText : 'UnknownStatus';
            error.type = 'Ajax Error: Collection';

            _this6.collectionErrors.push(error);

            throw error;
          });
        };
      });
      return views;
    }
  }, {
    key: "removeView",
    value: function removeView(view) {
      this.views = this.views.filter(function (v) {
        return v !== view;
      });

      if (view instanceof _Campaign["default"] || view.isHero && this.views[0]) {
        this.views[0].makeHero();

        this._renderLibbyTout();
      }
    }
  }, {
    key: "_updatePatronTitleStatus",
    value: function _updatePatronTitleStatus(views) {
      if (window.OverDrive.isAuthenticated && window.OverDrive.hasLinkedCards && views && views.length > 0) {
        var titles = [];
        views.forEach(function (view) {
          if (view instanceof _Campaign["default"]) {
            titles.push(view.model);
          } else {
            titles.push.apply(titles, _toConsumableArray(view.titleCollection.models));
          }
        });
        var patronTitleStatus = new _PatronTitleStatus["default"]();
        patronTitleStatus.fetchTitleStatus(titles).then(function () {
          patronTitleStatus.updateTitleCollectionState(_(titles));
        });
      }
    }
  }, {
    key: "_renderLibbyTout",
    value: function _renderLibbyTout() {
      var _this7 = this;

      if (this.libbytout) {
        this.libbytout.remove();
      }

      var frag = document.createDocumentFragment();

      if (this.featureManager.isEnabled('libbyTout') && this.featureManager.isEnabled('promoteLibby') && !this.room) {
        var $tout = $((0, _LibbyTout["default"])(window.OverDrive.optimizeForChina));

        if ((this.viewId || '').toLowerCase() === 'home') {
          $tout = $('<div class="Home-libbyTout" />').append($tout);
        }

        frag.appendChild($tout[0]);
        this.libbytout = $tout;
        $(window).on('resize scroll', function () {
          if (_this7.isInViewport(_this7.libbytout.find('.LibbyTout-wayPoint'))) {
            _this7.libbytout.find('.libbyIcon-container').addClass('libbyIcon-animate');
          } else {
            _this7.libbytout.find('.libbyIcon-container').removeClass('libbyIcon-animate');
          }
        });
      }

      this.views[0].$el.after(frag);
    }
  }, {
    key: "isInViewport",
    value: function isInViewport(element) {
      var elementTop = element.offset().top;
      var elementBottom = elementTop + element.outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();

      if (viewportTop === 0) {
        return false; // fake it when scroll is at the top, but image is still in view
      }

      return elementBottom > viewportTop && elementTop < viewportBottom;
    }
  }, {
    key: "_performForwardedAction",
    value: function _performForwardedAction() {
      if (isAuthenticated && hasLinkedCards && _HashManager["default"].get('action')) {
        var titles = [];

        if (this.campaignView) {
          titles.push(this.campaignView.model);
        }

        this.collectionManager.each(function (collectionDefinition) {
          titles.push.apply(titles, _toConsumableArray(collectionDefinition.titleCollection.models));
        });
        var forwardedAction = new _processForwardedAction["default"](new _TitleCollection["default"](titles), this.bus);
        forwardedAction.executeAction();
        window.forwardedAction = forwardedAction;
      }
    }
  }, {
    key: "_shouldTruncateCollections",
    get: function get() {
      // The OD app on iOS 8 and 9 crashes on the home page if there are too many collections.  LHTNG-2387
      var deviceInfo = detectshun.browser();
      var inApp = Cookies.get('omcbrowse') !== undefined;

      if (inApp && deviceInfo.ios && deviceInfo.bowser.osversion) {
        var versionParts = deviceInfo.bowser.osversion.split('.');

        if (versionParts && versionParts.length > 0) {
          var majorVersion = parseInt(versionParts[0], 10);

          if (majorVersion && majorVersion < 10) {
            return true;
          }
        }
      }

      return false;
    }
  }]);

  return PageView;
}(Backbone.View);

exports["default"] = PageView;